module.exports = __webpack_public_path__ + "static/img/icon_drawer.94737bd7.png";